var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanoee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #e7106e;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M534.2-34.2v568.5H-34.2V-34.2h568.5ZM80.6,418.3h23.3c1.1,0,17.2-7.6,19.5-8.9,91.1-51.4-7.6-187.1,88.8-234.1,87.6-42.7,164.9,69.6,98.8,135.7-19.9,19.9-35.3,21.5-61.6,24.3-19.3,2.1-42.7,17.8-42.7,39.2v43.8h76.7c13.8,0,48-16,60.3-23.9,106.2-67.4,101.3-229.5-8.5-290.6-110.1-61.2-244.4,9.9-254.8,134.1v180.3ZM218.6,218.6c-41.6,41.6,21.7,105.6,63.9,64.5,42.9-41.8-21.6-106.8-63.9-64.5Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250,
    cy: 250,
    r: 247.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-535.1,618.6v-158.5c9.1-109.3,127.2-171.8,224-118s100.9,196.3,7.5,255.5c-10.8,6.9-40.9,21-53,21h-67.5v-38.5c0-18.8,20.5-32.7,37.5-34.5,23.1-2.5,36.6-3.9,54.1-21.4,58.1-58.1-9.8-156.9-86.9-119.4-84.8,41.3,2,160.7-78.1,205.9-2.1,1.2-16.2,7.8-17.2,7.8h-20.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-373.6,142.4c37.2-37.2,93.9,19.9,56.2,56.7-37.1,36.2-92.8-20.1-56.2-56.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanoee);
export default __webpack_public_path__ + "static/media/panoee.deab27c74ad98f44e1a6b7c423e1e50e.svg";
export { ForwardRef as ReactComponent };